import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";

export const getCompanyListApiCall = createAsyncThunk("companyList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true));
        const { data: companyList } = await API.getCompanyListApi(submitData);
        dispatch(setLoader(false));
        return companyList;
    } catch (error) {
        throw error;
    }
});

export const editCompanyDataApiCall = createAsyncThunk("editCompanyData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true));
        const { data: editCompanyData, code, message } = await API.editCompanyDetailsApi(submitData);
        if (code === '1') {
            TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false));
        return { data: editCompanyData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    companyList: {
        data: [],
        error: null,
    },
    editCompanyData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const companySlice = createSlice({
    name: "COMPANY",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCompanyListApiCall.fulfilled, (state, action) => {
                state.companyList.data = action.payload;
            })
            .addCase(getCompanyListApiCall.rejected, (state, action) => {
                state.companyList.error = action.error.message;
            })
            .addCase(editCompanyDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editCompanyData.data = data;
                state.editCompanyData.message = message;
                state.editCompanyData.code = code;
            })
            .addCase(editCompanyDataApiCall.rejected, (state, action) => {
                state.editCompanyData.error = action.error.message;
            });
    },
});

export default companySlice.reducer;